import { useFlags } from "launchdarkly-react-client-sdk";
import Image from "next/image";

import LogoMobile from "@/assets/images/general/DogHeadMobile.png";
import Notifications from "@/components/notifications/Notifications";
import { HeaderCryptoHoldings } from "@/components/shared/layout/navbar/HeaderCryptoHoldings";
import { HeaderNumbers } from "@/components/shared/layout/navbar/header/HeaderNumbers";
import { UserDataDropdown } from "@/components/shared/layout/navbar/header/UserDataDropdown";
import { CryptoQueries } from "@/data/wallet/crypto/crypto.queries";

export const DesktopHeader = () => {
  const { cryptoWallet } = useFlags();

  return (
    <div className="flex h-[70px] w-full items-center justify-between border-elevation-outline-default-1 border-b bg-elevation-fill-default-0">
      <div className="@container/userdata flex min-w-0 flex-1 flex-row items-center justify-start">
        <div className="flex flex-none items-center justify-start border-elevation-outline-default-1 border-r px-4 py-2">
          <Image
            src={LogoMobile}
            alt="Lossdog"
            className="h-[56px] w-auto object-cover"
          />
        </div>
        <UserDataDropdown />
      </div>
      <div className="flex items-center gap-2 border-elevation-outline-default-1 border-l pl-2">
        {cryptoWallet && <HeaderCryptoBlock />}
        <HeaderNumbers />
        <div className="flex h-[70px] w-[70px] items-center justify-center border-elevation-outline-default-1 border-l p-2">
          <Notifications />
        </div>
      </div>
    </div>
  );
};

const HeaderCryptoBlock = () => {
  const { cryptoWallet } = useFlags();
  const { data: cryptoAssets, isError } = CryptoQueries.useGetPositions();
  const { data: unclaimedCashbacks } = CryptoQueries.useGetDisperseRewardStatus({ enabled: false });

  if (!cryptoWallet || isError || cryptoAssets == null) {
    return null;
  }

  const totalCryptoAmount = Number(cryptoAssets.totalNetLiq ?? 0);
  const hasRewardToClaim = unclaimedCashbacks?.status === "unclaimed" || unclaimedCashbacks?.status === "pending";
  const showClaimReward = hasRewardToClaim && totalCryptoAmount === 0;

  return (
    <HeaderCryptoHoldings
      totalCryptoAmount={totalCryptoAmount}
      showClaimReward={showClaimReward}
    />
  );
};
